// src/pages/admin/uniqueExperiences/schema/validations.js
import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { recommendation, item, itinerary, type, trendingStartD },
} = checkout;

// export a function that builds the schema based on isTrip
const buildSchema = (isTrip) => {
  const shape = {
    [trendingStartD.name]: Yup.string().required(trendingStartD.errorMsg),
  };

  if (isTrip) {
    // when it’s a trip, require “itinerary”
    shape[itinerary.name] = Yup.object().nullable().required(itinerary.errorMsg);
  } else {
    // when it’s NOT a trip, always require “type”
    shape[type.name] = Yup.string().required(type.errorMsg);

    // if type === "item", then item must be present
    shape[item.name] = Yup.string().when(type.name, {
      is: "item",
      then: () => Yup.string().required(item.errorMsg),
      otherwise: () => Yup.string().nullable(),
    });

    // if type === "recommendation", then recommendation must be present
    shape[recommendation.name] = Yup.object().when(type.name, {
      is: "recommendation",
      then: () => Yup.object().nullable().required(recommendation.errorMsg),
      otherwise: () => Yup.object().nullable(),
    });
  }

  return Yup.object().shape(shape);
};

export default buildSchema;
